import ReactDOM from "react-dom/client";
import App from "./App.tsx";
import { SessionContextProvider } from "./SessionContext.tsx";

// Bureaucracy imports
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faBars,
  faBan,
  faNoteSticky,
  faGears,
  faReceipt,
  faBagShopping,
  faCashRegister,
  faSackDollar,
  faStar,
  faHouse,
  faClock,
  faSeedling,
  faRobot,
  faArrowsRotate,
  faEnvelope,
  faXmark,
  faCircleXmark,
  faCheck,
  faCircleCheck,
  faCircleNotch,
  faUser,
  faMoneyBills,
  faPenToSquare,
  faFileLines,
  faTrash,
  faCalendar,
  faComment,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleChevronLeft,
  faCircleChevronRight,
  faCirclePlus,
  faSignature,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faBell,
  faBellSlash,
} from "@fortawesome/free-solid-svg-icons";
import { faInstagram, faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import moment from "moment";
import "moment/locale/pt.js";
import ErrorBoundary from "./pages/ErrorBoundary.tsx";

// Bureacracy setups
library.add(
  faBars,
  faBan,
  faNoteSticky,
  faGears,
  faReceipt,
  faBagShopping,
  faCashRegister,
  faSackDollar,
  faStar,
  faHouse,
  faClock,
  faSeedling,
  faRobot,
  faArrowsRotate,
  faEnvelope,
  faXmark,
  faCircleXmark,
  faCheck,
  faCircleCheck,
  faCircleNotch,
  faUser,
  faMoneyBills,
  faPenToSquare,
  faFileLines,
  faTrash,
  faCalendar,
  faComment,
  faInstagram,
  faWhatsapp,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircleChevronLeft,
  faCircleChevronRight,
  faCirclePlus,
  faSignature,
  faArrowUp,
  faArrowDown,
  faArrowLeft,
  faArrowRight,
  faBell,
  faBellSlash
);
moment.locale("pt");

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/service-worker.js");
}

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <ErrorBoundary>
    <SessionContextProvider>
      <App />
    </SessionContextProvider>
  </ErrorBoundary>
);
